/**
 * Stable CSS class names for E2E — Email Template Builder (add section route, create template, drawers, shared controls).
 */
export const ETBAS = {
    page: 'email-template-builder-add-section-page',
} as const;

export const ETBSCS = {
    root: 'email-template-builder-searchable-country-select',
    inputAutocomplete: 'email-template-builder-searchable-country-select-input--autocomplete',
} as const;

export const ETBCT = {
    page: 'email-template-builder-create-template-page',
    mainGrid: 'email-template-builder-create-template-page__main-grid',
    alertWrap: 'email-template-builder-create-template-page__alert-wrap',
    actionsRow: 'email-template-builder-create-template-page__actions-row',
    inputButtonAddSection: 'email-template-builder-create-template-input--button-add-section',
    inputButtonSaveTemplate: 'email-template-builder-create-template-input--button-save-template',
    previewPaper: 'email-template-builder-create-template-page__preview-paper',
} as const;

export const ETBCT_ADD_SUB = {
    drawerBody: 'email-template-builder-create-template-drawer-add-subsection__body',
    fieldCountry: 'email-template-builder-create-template-drawer-add-subsection-field--country',
    autocompleteCountryRoot: 'email-template-builder-create-template-drawer-add-subsection__autocomplete-country-root',
    inputAutocompleteCountry:
        'email-template-builder-create-template-drawer-add-subsection-input--autocomplete-country',
    fieldLanguage: 'email-template-builder-create-template-drawer-add-subsection-field--language',
    autocompleteLanguageRoot:
        'email-template-builder-create-template-drawer-add-subsection__autocomplete-language-root',
    inputAutocompleteLanguage:
        'email-template-builder-create-template-drawer-add-subsection-input--autocomplete-language',
    fieldSectionType: 'email-template-builder-create-template-drawer-add-subsection-field--section-type',
    autocompleteSectionTypeRoot:
        'email-template-builder-create-template-drawer-add-subsection__autocomplete-section-type-root',
    inputAutocompleteSectionType:
        'email-template-builder-create-template-drawer-add-subsection-input--autocomplete-section-type',
    fieldSection: 'email-template-builder-create-template-drawer-add-subsection-field--section',
    sectionAutocompleteWrap: 'email-template-builder-create-template-drawer-add-subsection__section-autocomplete-wrap',
    actionsFooter: 'email-template-builder-create-template-drawer-add-subsection__actions-footer',
    inputButtonAdd: 'email-template-builder-create-template-drawer-add-subsection-input--button-add',
} as const;

export const ETBCT_SAVE = {
    shell: 'email-template-builder-save-template-drawer',
    title: 'email-template-builder-save-template-drawer__title',
    fieldsColumn: 'email-template-builder-save-template-drawer__fields-column',
    fieldKeyword: 'email-template-builder-save-template-drawer-field--keyword',
    inputTextfieldKeyword: 'email-template-builder-save-template-drawer-input--textfield-keyword',
    fieldName: 'email-template-builder-save-template-drawer-field--name',
    inputTextfieldName: 'email-template-builder-save-template-drawer-input--textfield-name',
    fieldSubject: 'email-template-builder-save-template-drawer-field--subject',
    inputTextfieldSubject: 'email-template-builder-save-template-drawer-input--textfield-subject',
    fieldInclusiveToggle: 'email-template-builder-save-template-drawer-field--inclusive-toggle',
    fieldInclusiveSection: 'email-template-builder-save-template-drawer-field--inclusive-section',
    inputTextfieldInclusiveSection: 'email-template-builder-save-template-drawer-input--textfield-inclusive-section',
    fieldLanguage: 'email-template-builder-save-template-drawer-field--language',
    inputSelectLanguage: 'email-template-builder-save-template-drawer-input--select-language',
    fieldCountry: 'email-template-builder-save-template-drawer-field--country',
    actionsRow: 'email-template-builder-save-template-drawer__actions-row',
    inputButtonSave: 'email-template-builder-save-template-drawer-input--button-save',
} as const;

/** Editor add / edit section (Monaco + drawers). */
export const ETBED = {
    page: 'email-template-builder-editor-page',
    divider: 'email-template-builder-editor-page__divider',
    titleRow: 'email-template-builder-editor-page__title-row',
    saveToolbarRow: 'email-template-builder-editor-page__save-toolbar-row',
    inputButtonOpenSectionInfos: 'email-template-builder-editor-input--button-open-section-infos',
    tabsRow: 'email-template-builder-editor-page__tabs-row',
    workspacePaper: 'email-template-builder-editor-workspace',
    sidebarActions: 'email-template-builder-editor-page__sidebar-actions',
    inputButtonAddSubsectionContent: 'email-template-builder-editor-input--button-add-subsection-content',
    inputButtonAddSubsectionName: 'email-template-builder-editor-input--button-add-subsection-name',
    inputButtonAddParameter: 'email-template-builder-editor-input--button-add-parameter',
    editorPane: 'email-template-builder-editor-page__editor-pane',
    previewPane: 'email-template-builder-editor-page__preview-pane',
    previewScroll: 'email-template-builder-editor-page__preview-scroll',
} as const;

export const ETBED_INFOS = {
    shell: 'email-template-builder-editor-drawer-section-infos',
    fieldSectionName: 'email-template-builder-editor-drawer-section-infos-field--section-name',
    inputTextfieldSectionName: 'email-template-builder-editor-drawer-section-infos-input--textfield-section-name',
    fieldKeyword: 'email-template-builder-editor-drawer-section-infos-field--keyword',
    inputTextfieldKeyword: 'email-template-builder-editor-drawer-section-infos-input--textfield-keyword',
    fieldLanguage: 'email-template-builder-editor-drawer-section-infos-field--language',
    inputSelectLanguage: 'email-template-builder-editor-drawer-section-infos-input--select-language',
    fieldCountry: 'email-template-builder-editor-drawer-section-infos-field--country',
    fieldSectionType: 'email-template-builder-editor-drawer-section-infos-field--section-type',
    inputSelectSectionType: 'email-template-builder-editor-drawer-section-infos-input--select-section-type',
    actionsFooterAdd: 'email-template-builder-editor-drawer-section-infos__actions-footer-add',
    actionsFooterUpdate: 'email-template-builder-editor-drawer-section-infos__actions-footer-update',
    inputButtonAdd: 'email-template-builder-editor-drawer-section-infos-input--button-add',
    inputButtonUpdate: 'email-template-builder-editor-drawer-section-infos-input--button-update',
    spacerGrid: 'email-template-builder-editor-drawer-section-infos__spacer',
} as const;

export const ETBED_SUB_GALLERY = {
    drawerBody: 'email-template-builder-editor-drawer-pick-subsection-content__body',
    fieldCountry: 'email-template-builder-editor-drawer-pick-subsection-content-field--country',
    autocompleteCountryRoot: 'email-template-builder-editor-drawer-pick-subsection-content__autocomplete-country-root',
    inputAutocompleteCountry:
        'email-template-builder-editor-drawer-pick-subsection-content-input--autocomplete-country',
    fieldLanguage: 'email-template-builder-editor-drawer-pick-subsection-content-field--language',
    autocompleteLanguageRoot:
        'email-template-builder-editor-drawer-pick-subsection-content__autocomplete-language-root',
    inputAutocompleteLanguage:
        'email-template-builder-editor-drawer-pick-subsection-content-input--autocomplete-language',
    fieldSectionType: 'email-template-builder-editor-drawer-pick-subsection-content-field--section-type',
    autocompleteSectionTypeRoot:
        'email-template-builder-editor-drawer-pick-subsection-content__autocomplete-section-type-root',
    inputAutocompleteSectionType:
        'email-template-builder-editor-drawer-pick-subsection-content-input--autocomplete-section-type',
    fieldSection: 'email-template-builder-editor-drawer-pick-subsection-content-field--section',
    sectionAutocompleteWrap: 'email-template-builder-editor-drawer-pick-subsection-content__section-autocomplete-wrap',
    actionsFooter: 'email-template-builder-editor-drawer-pick-subsection-content__actions-footer',
    inputButtonAdd: 'email-template-builder-editor-drawer-pick-subsection-content-input--button-add',
} as const;

export const ETBED_PARAM = {
    shell: 'email-template-builder-editor-drawer-parameter',
    fieldKeywordSwitch: 'email-template-builder-editor-drawer-parameter-field--keyword-required',
    fieldParameterText: 'email-template-builder-editor-drawer-parameter-field--parameter-text',
    inputTextfieldParameter: 'email-template-builder-editor-drawer-parameter-input--textfield-parameter',
    spacerGrid: 'email-template-builder-editor-drawer-parameter__spacer',
    actionsFooter: 'email-template-builder-editor-drawer-parameter__actions-footer',
    inputButtonAdd: 'email-template-builder-editor-drawer-parameter-input--button-add',
} as const;

export const ETBED_SUB_NAME = {
    shell: 'email-template-builder-editor-drawer-subsection-name',
    fieldSectionType: 'email-template-builder-editor-drawer-subsection-name-field--section-type',
    autocompleteSectionTypeRoot:
        'email-template-builder-editor-drawer-subsection-name__autocomplete-section-type-root',
    inputAutocompleteSectionType:
        'email-template-builder-editor-drawer-subsection-name-input--autocomplete-section-type',
    fieldSectionSearch: 'email-template-builder-editor-drawer-subsection-name-field--section',
    subsectionAutocompleteWrap: 'email-template-builder-editor-drawer-subsection-name__subsection-autocomplete-wrap',
    spacerGrid: 'email-template-builder-editor-drawer-subsection-name__spacer',
    actionsFooter: 'email-template-builder-editor-drawer-subsection-name__actions-footer',
    inputButtonAdd: 'email-template-builder-editor-drawer-subsection-name-input--button-add',
} as const;

/** Edit section route (wraps editor when loading section by id). */
export const ETBES = {
    page: 'email-template-builder-edit-section-page',
    notFoundState: 'email-template-builder-edit-section-page__not-found',
} as const;

/** Section gallery list & filters. */
export const ETBSG = {
    page: 'email-template-builder-section-gallery-page',
    divider: 'email-template-builder-section-gallery-page__divider',
    toolbarGrid: 'email-template-builder-section-gallery-page__toolbar-grid',
    actionsPrimary: 'email-template-builder-section-gallery-page__actions-primary',
    filtersRow: 'email-template-builder-section-gallery-page__filters-row',
    fieldCountry: 'email-template-builder-section-gallery-field--country',
    autocompleteCountryRoot: 'email-template-builder-section-gallery__autocomplete-country-root',
    inputAutocompleteCountry: 'email-template-builder-section-gallery-input--autocomplete-country',
    fieldLanguage: 'email-template-builder-section-gallery-field--language',
    autocompleteLanguageRoot: 'email-template-builder-section-gallery__autocomplete-language-root',
    inputAutocompleteLanguage: 'email-template-builder-section-gallery-input--autocomplete-language',
    fieldSectionType: 'email-template-builder-section-gallery-field--section-type',
    autocompleteSectionTypeRoot: 'email-template-builder-section-gallery__autocomplete-section-type-root',
    inputAutocompleteSectionType: 'email-template-builder-section-gallery-input--autocomplete-section-type',
    inputTextfieldSearchKeyword: 'email-template-builder-section-gallery-input--textfield-search-keyword',
    inputButtonFilter: 'email-template-builder-section-gallery-input--button-filter',
    inputButtonCreateSection: 'email-template-builder-section-gallery-input--button-create-section',
    tableContainer: 'email-template-builder-section-gallery-page__table-container',
    table: 'email-template-builder-section-gallery-page__table',
    tableRow: 'email-template-builder-section-gallery-page__table-row',
    inputIconRowMenu: 'email-template-builder-section-gallery-input--icon-button-row-menu',
    menuItemEdit: 'email-template-builder-section-gallery-input--menu-item-edit',
    menuItemDelete: 'email-template-builder-section-gallery-input--menu-item-delete',
    paginationWrap: 'email-template-builder-section-gallery-page__pagination-wrap',
} as const;

/** Send test mail (template preview + parameters + recipient). */
export const ETBTM = {
    page: 'email-template-builder-send-test-mail-page',
    rootGrid: 'email-template-builder-send-test-mail-page__root-grid',
    summaryPaper: 'email-template-builder-send-test-mail-summary',
    summaryPaperGrid: 'email-template-builder-send-test-mail-summary__paper-grid',
    summaryHeaderRow: 'email-template-builder-send-test-mail-summary__header-row',
    summaryMetaColumn: 'email-template-builder-send-test-mail-summary__meta-column',
    subjectTitle: 'email-template-builder-send-test-mail-summary__subject-title',
    keySubtitle: 'email-template-builder-send-test-mail-summary__key-subtitle',
    sendColumn: 'email-template-builder-send-test-mail-summary__send-column',
    emailLabelRow: 'email-template-builder-send-test-mail-summary__email-label-row',
    emailCompositeWrap: 'email-template-builder-send-test-mail-summary__email-composite-wrap',
    spacerRow: 'email-template-builder-send-test-mail-summary__spacer-row',
    mainSplitRow: 'email-template-builder-send-test-mail-page__main-split-row',
    mailPropsColumn: 'email-template-builder-send-test-mail-page__properties-column',
    previewColumn: 'email-template-builder-send-test-mail-page__preview-column',
    mailPropsPaper: 'email-template-builder-send-test-mail-properties',
    mailPropsSettingsHeader: 'email-template-builder-send-test-mail-properties__mail-settings-header',
    mailPropsParametersHeader: 'email-template-builder-send-test-mail-properties__parameters-header',
    fieldCreatedBy: 'email-template-builder-send-test-mail-properties-field--created-by',
    inputTextfieldCreatedBy: 'email-template-builder-send-test-mail-properties-input--textfield-created-by',
    fieldCreatedOn: 'email-template-builder-send-test-mail-properties-field--created-on',
    inputTextfieldCreatedOn: 'email-template-builder-send-test-mail-properties-input--textfield-created-on',
    parametersIntro: 'email-template-builder-send-test-mail-properties__parameters-intro',
    requiredParametersGrid: 'email-template-builder-send-test-mail-properties__required-parameters-grid',
    otherParametersGrid: 'email-template-builder-send-test-mail-properties__other-parameters-grid',
    parameterFieldRequired: 'email-template-builder-send-test-mail-parameter-field--required',
    parameterInputRequired: 'email-template-builder-send-test-mail-parameter-input--textfield-required',
    parameterFieldOptional: 'email-template-builder-send-test-mail-parameter-field--optional',
    parameterInputOptional: 'email-template-builder-send-test-mail-parameter-input--textfield-optional',
    previewContent: 'email-template-builder-send-test-mail-preview__content',
} as const;

/** Template gallery list & filters. */
export const ETBTG = {
    page: 'email-template-builder-template-gallery-page',
    divider: 'email-template-builder-template-gallery-page__divider',
    toolbarGrid: 'email-template-builder-template-gallery-page__toolbar-grid',
    primaryActionsGrid: 'email-template-builder-template-gallery-page__primary-actions-grid',
    inputButtonCreateTemplate: 'email-template-builder-template-gallery-input--button-create-template',
    inputButtonCreateSection: 'email-template-builder-template-gallery-input--button-create-section',
    filtersRow: 'email-template-builder-template-gallery-page__filters-row',
    fieldCountry: 'email-template-builder-template-gallery-field--country',
    autocompleteCountryRoot: 'email-template-builder-template-gallery__autocomplete-country-root',
    inputAutocompleteCountry: 'email-template-builder-template-gallery-input--autocomplete-country',
    fieldLanguage: 'email-template-builder-template-gallery-field--language',
    autocompleteLanguageRoot: 'email-template-builder-template-gallery__autocomplete-language-root',
    inputAutocompleteLanguage: 'email-template-builder-template-gallery-input--autocomplete-language',
    searchCompositeWrap: 'email-template-builder-template-gallery__search-filter-composite-wrap',
    tableContainer: 'email-template-builder-template-gallery-page__table-container',
    table: 'email-template-builder-template-gallery-page__table',
    tableRow: 'email-template-builder-template-gallery-page__table-row',
    sendTestMailCellWrap: 'email-template-builder-template-gallery-page__send-test-mail-cell-wrap',
    inputButtonSendTestMail: 'email-template-builder-template-gallery-input--button-send-test-mail',
    inputIconDeleteTemplate: 'email-template-builder-template-gallery-input--icon-button-delete-template',
    paginationWrap: 'email-template-builder-template-gallery-page__pagination-wrap',
} as const;

/** Email Template Builder hub (landing tiles + breadcrumb). */
export const ETBHUB = {
    page: 'email-template-builder-hub-page',
    layoutShell: 'email-template-builder-hub-page__layout-shell',
    headerRow: 'email-template-builder-hub-page__header-row',
    bodyShell: 'email-template-builder-hub-page__body-shell',
    tilesInnerShell: 'email-template-builder-hub-page__tiles-inner-shell',
    tilesRow: 'email-template-builder-hub-page__tiles-row',
    linkCreateTemplate: 'email-template-builder-hub-input--link-create-template',
    linkAddSection: 'email-template-builder-hub-input--link-add-section',
    linkSectionsGallery: 'email-template-builder-hub-input--link-sections-gallery',
    linkTemplateGallery: 'email-template-builder-hub-input--link-template-gallery',
    tileCreateTemplate: 'email-template-builder-hub-page__tile-create-template',
    tileAddSection: 'email-template-builder-hub-page__tile-add-section',
    tileSectionsGallery: 'email-template-builder-hub-page__tile-sections-gallery',
    tileTemplateGallery: 'email-template-builder-hub-page__tile-template-gallery',
    tileImage: 'email-template-builder-hub-page__tile-image',
    tileCaption: 'email-template-builder-hub-page__tile-caption',
    tileCaptionTitle: 'email-template-builder-hub-page__tile-caption-title',
} as const;

export const etbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
